export * from './IconBackArrow';
export { default as IconBackArrow } from './IconBackArrow';
